import PGnatConfig from './components/pgnatConfig/PGnatConfig.vue';
import GnatConfig from './components/gnatConfig/GnatConfig.vue';
import APTConfig from './components/aptConfig/APTConfig.vue';
import ProjectHome from './components/ProjectHome.vue';

export const routes = [
    {path: '/', component: ProjectHome, name: 'Home'},
    {path: '/pgnatConfig', component: PGnatConfig, name: 'pgnatConfig'},
    {path: '/gnatConfig', component: GnatConfig, name: 'gnatConfig'},
    {path: '/aptConfig', component: APTConfig, name: 'aptConfig'},
]



// WEBPACK FOOTER //
// ./src/routes.js